module.exports = ".width-100 {\n  width: 100%;\n}\n\n.flexbox-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/book/distributore-selector/distributore-selector.component.css
// module id = ./src/app/components/book/distributore-selector/distributore-selector.component.css
// module chunks = main